import {useEffect, useState} from 'react';
import axios from 'axios';
import styles from './StickyAnnouncement.module.scss';

export function isPromotionLink(value) {
    if (typeof value !== 'string' || /[\s\\]/.test(value) ||
        Array.from(value).some(char => char.charCodeAt(0) < 32 || char.charCodeAt(0) === 127)) return false;
    if (/^\/(?!\/)/.test(value)) return true;
    try {
        const url = new URL(value);
        return url.protocol === 'https:' || url.protocol === 'http:';
    } catch {
        return false;
    }
}

export default function StickyAnnouncement() {
    const [promotion, setPromotion] = useState(null);
    const [dismissed, setDismissed] = useState(false);

    useEffect(() => {
        const controller = new AbortController();
        // Optional marketing content must not trigger the global API error screen.
        axios.get(`${process.env.REACT_APP_API_URL}/api/sticky-banner-promotion`, {
            signal: controller.signal,
            timeout: 8000,
        }).then(({data}) => {
            if (!controller.signal.aborted) setPromotion(data.data);
        }).catch(() => {});
        return () => controller.abort();
    }, []);

    if (dismissed || !promotion?.status || !promotion.campaign_name || !promotion.display_discription ||
        !promotion.button_text || !isPromotionLink(promotion.button_link)) return null;

    return (
        <aside className={styles.bar} aria-label={promotion.campaign_name}>
            <div className={styles.content}>
                <svg className={styles.gift} viewBox="0 0 24 24" fill="none" stroke="currentColor"
                     strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                    <path d="M3 8h18v4H3zM5 12v9h14v-9M12 8v13"/>
                    <path d="M12 8H8a3 3 0 1 1 3-3l1 3Zm0 0h4a3 3 0 1 0-3-3l-1 3Z"/>
                </svg>
                <span className={styles.copy}>
                    <strong>{promotion.campaign_name}</strong>
                    <span className={styles.separator} aria-hidden="true"> | </span>
                    <span className={styles.description}>{promotion.display_discription}</span>
                </span>
                <a className={styles.button} href={promotion.button_link}>
                    {promotion.button_text}<span aria-hidden="true">›</span>
                </a>
            </div>
            <button type="button" className={styles.close} aria-label="お知らせを閉じる"
                    onClick={() => setDismissed(true)}>
                <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.4" aria-hidden="true">
                    <path d="m3 3 10 10M13 3 3 13"/>
                </svg>
            </button>
        </aside>
    );
}
